<sf-card icon="circle-info" cardTitle="Job Details" [showCollapseButton]="true">
    <ng-container [formGroup]="form">
        <sf-label for="jobType" label="Job Type"></sf-label>
        <ng-select
            id="jobType"
            placeholder="Select template"
            [items]="smartQuoteTemplates$ | async"
            bindValue="id"
            bindLabel="name"
            (change)="onJobTypeChange($event)">
            <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="card">
                    <div class="card-body">
                        <p class="fw-bold mb-1">{{ item.name }}</p>
                        <p class="mb-0" [innerText]="item.description"></p>
                    </div>
                </div> </ng-template
        ></ng-select>
        <p class="small text-muted">Select an item from the dropdown above to pre-populate the job description.</p>

        <ul ngbNav #nav="ngbNav" class="c-nav c-nav-underline nav-fill">
            <li ngbNavItem>
                <button ngbNavLink>Job Description</button>
                <ng-template ngbNavContent
                    ><sf-input-textarea
                        label="Job Description"
                        inputId="notes"
                        [maxLength]="2000"
                        [rows]="3"
                        formControlName="notes"></sf-input-textarea
                ></ng-template>
            </li>
            <li ngbNavItem>
                <button ngbNavLink>Staff Notes</button>
                <ng-template ngbNavContent
                    ><sf-input-textarea
                        label="Staff Notes"
                        inputId="notes"
                        [maxLength]="2000"
                        [rows]="3"
                        formControlName="staffNotes"></sf-input-textarea
                ></ng-template>
            </li>
            <li ngbNavItem>
                <button ngbNavLink>Engineer Notes</button>
                <ng-template ngbNavContent
                    ><sf-input-textarea
                        label="Engineer Notes"
                        inputId="notes"
                        [maxLength]="2000"
                        [rows]="3"
                        formControlName="engineerNotes"></sf-input-textarea
                ></ng-template>
            </li>
        </ul>
        <div class="mt-2" [ngbNavOutlet]="nav"></div>
    </ng-container>
</sf-card>
